<div *ngIf="accession()">
  <div class="mt-8 mb-10"><app-back-button /></div>

  <div>
    <div class="flex justify-between mb-10">
      <div class="flex flex-col gap-2">
        <div class="flex items-start">
          <h1 class="text-[30px] font-bold">{{ accession()?.title }}</h1>
        </div>

        <div
          id="title"
          class="font-bold text-[18px] text-neutral-dark">
          Adhesión {{ accession()?.id }}
        </div>
        <div class="flex gap-2 items-center mt-8">
          <div
            class="w-4 h-4"
            [ngClass]="colorBox()"></div>
          <div class="text-md font-semibold">{{ stateTextFormat() }}</div>
          <div class="mx-8 flex gap-2">
            <span class="text-md">
              Solicitada el {{ accession()?.creationDate ? ($any(accession()?.creationDate) | spanishDate) : '' }}
            </span>
            <span class="text-md">por {{ accession()?.creationUser | titlecase }} - {{ accession()?.userPost }}</span>
          </div>
        </div>
      </div>

      <div class="flex gap-4 items-start">
        @if (list === 'received') {
          @if (buttonsOptions && buttonsOptions.options) {
            @for (b of buttonsOptions.options; track b.label) {
              <div class="text-sm text-primary-600 cursor-pointer">
                <desy-button
                  (clickEvent)="b.action(b)"
                  classes="c-button c-button--sm c-button--primary ng-star-inserted">
                  {{ b.label }}
                </desy-button>
              </div>
            }
          }
        }
        @if (list === 'sent' && accession()?.state?.toLowerCase() !== 'finished') {
          @if (accession()?.action) {
            <div class="text-sm text-primary-600 cursor-pointer flex items-end">
              <desy-button
                (clickEvent)="navigateToEditRpts(accession()?.id ?? '')"
                classes="c-button c-button--sm c-button--primary ng-star-inserted">
                Modificar Rpts
              </desy-button>
            </div>
          }
          @if (buttonsOptions && buttonsOptions.options) {
            @for (b of buttonsOptions.options; track b.label) {
              <div class="text-sm text-primary-600 cursor-pointer">
                <desy-button
                  (clickEvent)="b.action(b)"
                  classes="c-button c-button--sm c-button--primary ng-star-inserted">
                  {{ b.label }}
                </desy-button>
              </div>
            }
          }
        }
      </div>
    </div>
    <app-review-states
      [context]="'accession'"
      [stateGroups]="stateGroup"
      [dpd]="isDpd"></app-review-states>
    <div class="mt-10">
      <app-collapsible
        [title]="'Campos de consulta'"
        [open]="true"
        [items]="$any(accession()?.protocol ?? [])" />
      <app-collapsible
        [title]="'Servicios'"
        [open]="false"
        [description]="accession()?.service ?? ''" />

      <app-collapsible
        [title]="'Normativa'"
        [open]="false"
        [url]="accession()?.regulationsUrl ?? ''"
        [type]="'1'"
        [regulation]="regulationData" />
      <!-- <app-collapsible
      [title]="'Tiempo de vigencia'"
      [open]="false"
      [description]="
        accession()?.limitTime ? (accession()?.limitTime | spanishDate) : 'Indefinida'
      "></app-collapsible> -->
      <app-collapsible
        [title]="'Rpts asociados: ' + (accession()?.rpts?.length ?? 0)"
        [open]="false"
        [itemsTableHeader]="['Nombre', 'Puesto', 'Organismo', 'Email']"
        [itemsTableRows]="$any(rptsFormated ?? [])" />
      <app-collapsible
        [title]="'Observaciones'"
        [open]="false"
        [description]="accession()?.observations || 'No hay observaciones'"></app-collapsible>
    </div>
  </div>
</div>
<p-confirmdialog />
